export * from "modules/IncompleteTyresDashboard/components/DeleteTyreModal/hooks/useDeleteTyreMutation";
